import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyBtZl5yYXqGZDmUf1qgvucMj7hDYc0lUgs",
    authDomain: "sen-app-af09c.firebaseapp.com",
    projectId: "sen-app-af09c",
    storageBucket: "sen-app-af09c.appspot.com",
    messagingSenderId: "456197678793",
    appId: "1:456197678793:web:4e9ea657e84c96db308f18",
})

const db = firebaseApp.firestore();

const auth = firebase.auth();

export { db, auth };